



















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  AlignJustifyIcon,
  CreditCardIcon,
  Edit2Icon,
  MailIcon,
  LockIcon,
  SettingsIcon,
  // @ts-ignore
} from "vue-feather-icons";

@Component({
  components: {
    AlignJustifyIcon,
    CreditCardIcon,
    Edit2Icon,
    LockIcon,
    MailIcon,
    SettingsIcon,
  },
})
export default class UserSettingsMenu extends Vue {
  isActiveMenuItem(name: string): boolean {
    if (this.$route.name === name) {
      return true;
    }

    return false;
  }
}
